import React, { useState, useEffect } from 'react';
import { BibleIndex } from '../types/bible';

interface ChapterListProps {
  book: BibleIndex;
  onChapterSelect: (book: BibleIndex, chapter: number) => void;
  onBack: () => void;
}

const ChapterList: React.FC<ChapterListProps> = ({ book, onChapterSelect, onBack }) => {
  const chapters = Array.from({ length: book.chapters }, (_, i) => i + 1);
  const [isMobile, setIsMobile] = useState<boolean>(false);

  // 화면 크기 감지
  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);

    return () => {
      window.removeEventListener('resize', checkIsMobile);
    };
  }, []);

  // 모바일에서 렌더링 문제 해결을 위한 강제 리렌더링
  useEffect(() => {
    if (isMobile) {
      // 컴포넌트 마운트 후 강제 리렌더링
      const timer = setTimeout(() => {
        window.scrollTo(0, 0);
        // 뷰포트 강제 업데이트
        const viewport = document.querySelector('meta[name="viewport"]');
        if (viewport) {
          viewport.setAttribute('content', 'width=device-width, initial-scale=1.0');
        }
      }, 50);

      return () => clearTimeout(timer);
    }
  }, [isMobile]);

  return (
    <div style={{ padding: '20px' }}>
      {/* 이전 버튼 - 헤더 바로 아래 왼쪽 정렬 */}
      <div style={{ marginBottom: '10px', textAlign: 'left' }}>
        <button 
          onClick={onBack}
          style={{
            padding: '8px 16px',
            backgroundColor: '#6c757d',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '14px'
          }}
        >
          ← 이전
        </button>
      </div>
      
      {/* 성경 제목 - 별도 줄 */}
      <div style={{ maxWidth: '800px', margin: '0 auto', marginBottom: '20px' }}>
        <h2 style={{ 
          margin: 0, 
          color: book.bookNo <= 39 ? '#8b4513' : '#1e40af',
          textAlign: 'center',
          fontSize: isMobile ? '1.0rem' : undefined,
          fontWeight: 'bold'
        }}>
          {book.name} ({book.code})
        </h2>
      </div>
      
      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: isMobile 
          ? 'repeat(auto-fill, minmax(60px, 1fr))' 
          : 'repeat(auto-fill, minmax(80px, 1fr))', 
        gap: isMobile ? '6px' : '10px' 
      }}>
        {chapters.map((chapter) => (
          <div 
            key={chapter}
            onClick={() => onChapterSelect(book, chapter)}
            style={{ 
              border: '1px solid #ddd', 
              borderRadius: isMobile ? '6px' : '8px', 
              padding: isMobile ? '8px 4px' : '15px',
              backgroundColor: book.bookNo <= 39 ? '#f8f9fa' : '#e8f4fd',
              textAlign: 'center',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              fontSize: isMobile ? '12px' : '16px',
              fontWeight: 'bold',
              color: book.bookNo <= 39 ? '#8b4513' : '#1e40af',
              minHeight: isMobile ? '40px' : 'auto',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = book.bookNo <= 39 ? '#e9ecef' : '#d1ecf1';
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.1)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = book.bookNo <= 39 ? '#f8f9fa' : '#e8f4fd';
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
{book.name === '시편' ? `${chapter}편` : `${chapter}장`}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ChapterList;
